<!-- button when user has searched -->
@if (bookingParameters.userDefinedSearch) {
  <!-- display original version in v1 and v3 -->
  <div
    class="mt-auto"
    [class.loading]="
      (isLoadingNewPriceData && shop.inTown) || (isLoadingNewOutOfTownPriceData && !shop.inTown)
    ">
    <div
      class="row m-0 mb-2 discount-details"
      style="display: flex"
      [class.opacityZero]="shop.discount === 0">
      <div class="col col-6 text-center">
        <span>{{ 'PROCEED_TO_PRODUCT_LIST.inStorePrice' | alpitranslate }}</span>
        <span>{{ shop.defaultProductBasePriceRaw | alpicurrency: currencyCode }}</span>
      </div>
      <div class="col col-6 text-center">
        <span>{{ 'PROCEED_TO_PRODUCT_LIST.youSave' | alpitranslate }}</span>
        @if (
          shop.hasDiscount &&
          ((!isLoadingNewPriceData && shop.inTown) || (!isLoadingNewOutOfTownPriceData && !shop.inTown))
        ) {
          <span>{{ getDifference() }}</span>
        } @else {
          <app-icon name="circleNotch" class="mx-auto" />
        }
      </div>
    </div>
    <div class="pr-2 pl-2 pl-lg-0 pr-lg-0 pb-2 pb-lg-0">
      <a
        data-test="proceedToShopLink"
        target="_blank"
        href="{{ productLink }}"
        class="btn btn-primary btn-lowest-price p-2">
        <span class="text-small text-uppercase">{{
          'PROCEED_TO_PRODUCT_LIST.lowestPricePackageFrom' | alpitranslate
        }}</span>
        <span
          data-test="price"
          class="text-price"
          [innerHTML]="shop.defaultProductOnlineAmount | alpicurrency: currencyCode"></span>
        <app-icon name="rightArrow" />
      </a>
    </div>
  </div>
} @else {
  <div class="mt-auto">
    <div
      class="row m-0 mb-2 discount-details"
      style="display: flex"
      [class.opacityZero]="shop.discount === 0">
      <div class="col col-6 text-center">
        <span>{{ 'PROCEED_TO_PRODUCT_LIST.inStorePrice' | alpitranslate }}</span>
        <span>{{ shop.defaultProductBasePriceRaw | alpicurrency: currencyCode }}</span>
      </div>
      <div class="col col-6 text-center">
        <span>{{ 'PROCEED_TO_PRODUCT_LIST.youSave' | alpitranslate }}</span>
        @if (
          shop.hasDiscount &&
          ((!isLoadingNewPriceData && shop.inTown) || (!isLoadingNewOutOfTownPriceData && !shop.inTown))
        ) {
          <span>{{ shop.difference | alpicurrency: currencyCode }}</span>
        } @else {
          <app-icon name="circleNotch" class="mx-auto" />
        }
      </div>
    </div>
    <div class="pr-2 pl-2 pl-lg-0 pr-lg-0 pb-3">
      <a target="_blank" href="{{ productLink }}" class="btn btn-primary btn-lowest-price p-2">
        <span
          class="text-small text-uppercase"
          [innerHTML]="'PROCEED_TO_PRODUCT_LIST.goToProductsDateNotSelected' | alpitranslate"></span>
        @if (
          shop.hasDiscount &&
          ((!isLoadingNewPriceData && shop.inTown) || (!isLoadingNewOutOfTownPriceData && !shop.inTown))
        ) {
          <span
            class="text-price"
            [innerHTML]="shop.defaultProductOnlineAmount | alpicurrency: currencyCode"></span>
        } @else {
          <app-icon name="circleNotch" class="mx-auto" />
        }
        <app-icon name="rightArrow" />
      </a>
    </div>
  </div>
}
<!-- button when user has searched and shop is ready for a booking -->
